document.addEventListener("DOMContentLoaded", function () {
  function removeEmptyBlocks() {
    const footerWrapper = document.querySelector(".footer-main-wrapper");
    const children = Array.from(footerWrapper.children);

    children.forEach((block) => {
      if (getComputedStyle(block).display === "none") {
        block.remove();
      }
    });
  }

  function initFooterAnimation() {
    const footer = document.querySelector(".shopify-section-footer");
    const footerAnimation = footer.querySelector(".animation-enabled");

    if (!footerAnimation) return;

    let prevElem = footer.previousElementSibling;

    if (prevElem.ariaHidden === "true") {
      prevElem = prevElem.previousElementSibling;
    }

    const startSentinel = document.createElement("div");
    startSentinel.style.height = "1px";
    startSentinel.style.background = "rgb(var(--color-background))";
    prevElem.insertAdjacentElement("beforebegin", startSentinel);

    const startObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          footer.classList.add("is-active");
        }
      },
      {
        threshold: 1,
      }
    );

    startObserver.observe(startSentinel);

    const endSentinel = document.createElement("div");
    endSentinel.style.height = "1px";
    endSentinel.style.background = "rgb(var(--color-background))";
    footer.insertAdjacentElement("afterend", endSentinel);

    const endObserver = new IntersectionObserver(
      ([entry]) => {
        const isDetailsOpen = Array.from(
          footer.querySelectorAll(".footer-menu-block-mobile-element")
        ).some((el) => el.attributes["open"]);

        if (entry.isIntersecting) {
          footer.classList.remove("is-active");
          footer.classList.add("is-ended");
        } else if (!isDetailsOpen) {
          footer.classList.remove("is-ended");
          footer.classList.add("is-active");
        }
      },
      {
        threshold: 0,
      }
    );

    endObserver.observe(endSentinel);
  }

  removeEmptyBlocks();
  initFooterAnimation();
});
